import Nullstack from "nullstack";
import Application from "./src/Application";
const context = Nullstack.start(Application);
context.start = async function start() {
// https://nullstack.app/application-startup
};
export default context;

    if (module.hot) {
      if (Nullstack.needsClientReload) {
        window.location.reload()
      }
      module.hot.accept()
      Nullstack.needsClientReload = true
      module.hot.accept('./src/Application', () => {
        Nullstack.hotReload(Application)
      })
    }
  